import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Pathname from './Pathname';
import Permission from './Permission';

import myDoc from '../assets/images/mydoc.png';
import operated from '../assets/images/operated.png';
import cc_box from '../assets/images/operated.png';
import page_forward from '../assets/images/page_forward.png';
import page_back from '../assets/images/page_back.png';
import file_text from '../assets/images/file_text.png';
import page_find from '../assets/images/page_find.png';
import page_cancel from '../assets/images/page_cancel.png';

class DocumentSidebar extends Component {
  render(){
    var fullPathname = Pathname.fullPathname(this.props.location);

    var isActiveMyDoc = false;
    if ((fullPathname === '/documents/mydoc' || fullPathname === '/' || fullPathname === '')){
      isActiveMyDoc = true;
    }
    return(
      <div className="documents-sidebar pl-4 pl-lg-0 sub-sidebar-menu">
        <ul className="nav flex-column nav-pills py-4" id="v-pills-tab" role="tablist">
          <li className="nav-item">
            <Link to='/documents/mydoc' className={`nav-link ${isActiveMyDoc && 'active'}`}>
              <img alt="myDoc" src={myDoc} className="mr-2" />
              เอกสารของฉัน
            </Link>
          </li>
          <li className="nav-item">
            <Link to='/documents/operated' className={`nav-link ${(fullPathname === '/documents/operated') && 'active'}`}>
              <img alt="Operated" src={operated} className="mr-2" />
              เอกสารดำเนินการแล้ว
            </Link>
          </li>
          {Permission.isSecretary() && (
            <li className="nav-item">
              <Link to='/documents/cc_box' className={`nav-link ${(fullPathname === '/documents/cc_box') && 'active'}`}>
                <img alt="CcBox" src={cc_box} className="mr-2" />
                เอกสารสำเนาถึง
              </Link>
            </li>
          )}
          <li className="nav-item">
            <Link to='/documents/draft' className={`nav-link ${(fullPathname === '/documents/draft') && 'active'}`}>
              <img alt="Draft" src={file_text} className="mr-2" />
              ร่างหนังสือ
            </Link>
          </li>
          {Permission.canBookNumber() && (
            <li className="nav-item">
              <Link to='/documents/send_all' className={`nav-link ${(fullPathname === '/documents/send_all') && 'active'}`}>
                <img alt="sentDoc" src={page_forward} className="mr-2" />
                ทะเบียนหนังสือส่ง
              </Link>
            </li>
          )}
          {Permission.canBookNumber() && (
            <li className="nav-item">
              <Link to='/documents/receive_all' className={`nav-link ${(fullPathname === '/documents/receive_all') && 'active'}`}>
                <img alt="Receive" src={page_back} className="mr-2" />
                ทะเบียนหนังสือรับ
              </Link>
            </li>
          )}
          <li className="nav-item">
            <Link to='/documents/order' className={`nav-link ${(fullPathname === '/documents/order') && 'active'}`}>
              <img alt="Order" src={file_text} className="mr-2" />
              ทะเบียนคุมคำสั่ง
            </Link>
          </li>
          <li className="nav-item">
            <Link to='/documents/search' className={`nav-link ${(fullPathname === '/documents/search') && 'active'}`}>
              <img alt="Search" src={page_find} className="mr-2" />
              ค้นหาทะเบียนหนังสือ
            </Link>
          </li>
          <li className="nav-item">
            <Link to='/documents/cancel' className={`nav-link ${(fullPathname === '/documents/cancel') && 'active'}`}>
              <img alt="Cancel" src={page_cancel} className="mr-2" />
              เอกสารยกเลิก
            </Link>
          </li>
        </ul>
      </div>
    )
  }
}

export default DocumentSidebar;


// WEBPACK FOOTER //
// ./src/components/DocumentSidebar.js